module.exports = __webpack_public_path__ + "static/media/gifi3.81d3b3db.jpg";